import { DonationConfirmationSheetComponent } from './../../../donation-confirmation/components/donation-confirmation-sheet/donation-confirmation-sheet.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Location } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ICurrency } from '../../../../shared/models/currency.model';
import { PaymentUtilService } from '../../services';
import { UtilService, VariablesService } from '../../../../shared/services';
import {
  DonationConfirmationComponent
} from '../../../donation-confirmation/components/donation-confirmation/donation-confirmation.component';
import { IFundraiser } from 'src/app/shared/models/fundraiser.model';

@Component({
  selector: 'app-payment-header',
  templateUrl: './payment-header.component.html',
  styleUrls: ['./payment-header.component.scss']
})
export class PaymentHeaderComponent implements OnInit {
  @Input() public fundraiser: IFundraiser;
  @Input() isReward;
  @Input() selectedCurrency;
  @Input() screenName;
  @Input() showBeneficiary;
  @Input() contributeDetails;
  @Input() isStandAlone;
  @Input() type = 'v1';
  @Input() tiptyp;
  @Output() userSelectionCurrency: EventEmitter<ICurrency> = new EventEmitter();
  supportedCurrencies: ICurrency[];
  currency;
  params;
  currentUrl;
  isMobile;
  constructor(
    private paymentUtilService: PaymentUtilService,
    public utilService: UtilService,
    public location: Location,
    private actRoute: ActivatedRoute,
    public dialog: MatDialog,
    public router: Router,
    public vars: VariablesService,
    private bottomSheet: MatBottomSheet
  ) { }

  ngOnInit() {
    this.isMobile = this.utilService?.isMobile();
    this.getCurrencyDetails();
    this.actRoute.queryParams.subscribe((params) => {
      this.params = params;
    });
  }
  /**Get the details of the currency */
  getCurrencyDetails() {
    this.paymentUtilService.supportedCurrencies.subscribe({
      next: (res) => {
        if (res) {
          setTimeout(() => {
            this.supportedCurrencies = res;
          }, 0);
        }
      }
    });
    this.paymentUtilService.paymentCurrency.subscribe({ next: (res) => this.currency = res });
  }
  /**Get the title */
  getTitle(param, op) {
    if (op && this.utilService.isMobile()) {
      switch (op) {
        case 'c': return this.utilService.isMobile() ? '' : 'Enter your card details';
        case 'p': return 'Payment using PayTM';
      }
    } else {
      switch (param) {
        case 'rd':
          return 'Choose Reward amount';
        case 'form':
          return 'Choose a donation amount';
        case 'options':
          return 'Choose payment option';
      }
    }
  }
  /**Get emited currency fromheader and set it */
  setCurrency(currency: ICurrency) {
    this.paymentUtilService.paymentCurrency.next(currency.currency);
    this.userSelectionCurrency.emit(currency);
  }
  /**Back action of payment header */
  back() {
    if (this.screenName === this.params.payment && !this.params.op) {
      if (this.isStandAlone) {
        this.location.back();
        return;
      }
      if (!this.utilService.isMobile()) {
        const dialogRef = this.dialog.open(DonationConfirmationComponent, {
          data: { contributeDetails: this.contributeDetails, currency: this.currency },
          width: '100%',
          height: 'auto',
          maxWidth: '500px',
          maxHeight: '536px',
          panelClass: 'confirmation-modal'
        });
        dialogRef.componentInstance.cancelPayment.subscribe(() => {
          if (this.isStandAlone) {
            this.location.back();
          }
        });
      } else if (this.utilService.isMobile()) {
        const bottomSheetRef = this.bottomSheet.open(DonationConfirmationSheetComponent, {
          data: { contributeDetails: this.contributeDetails, currency: this.currency },
          panelClass: 'confirmation-modal-sheet'
        });
        bottomSheetRef.afterDismissed().subscribe((val) => {
        });
      } else {
        this.dialog.closeAll();
      }
    } else if (this.params?.st === 'f' && this.params?.payment === 'options' && !this.params?.op && this.isStandAlone) {
      this.router.navigate([], { queryParams: { payment: 'form' }, queryParamsHandling: 'merge' });
    } else {
      this.location.back();
      this.paymentUtilService.backButton.next(this.params);
      this.paymentUtilService.cartSubs.forEach(s => s.unsubscribe());
    }
  }

}
